import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "LugarPage",
    data() {
        let ss = new MainService();
        return {
            msg: "LugarPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexLugar(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: true, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'CodigoLugar', name: 'CodigoLugar', title: 'Codigo Lugar' },
                { data: 'Lugar', name: 'Lugar', title: 'Lugar' },
                { data: 'Sigla', name: 'Sigla', title: 'Sigla' },
                { data: 'Area', name: 'Area', title: 'Area' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            lugar: {},
            
        };
    },
    methods: {
        
        newLugar() {
            this.lugar = {};
            this.$refs['frm-lugar'].show();
            // console.log("hhhhola")
        },
        showLugar(id) {
            this.isLoading=true;
            this.ss.showLugar(id).then(
                (result) => {
                    let response = result.data;
                    this.lugar = response.data;
                    this.$refs['view-lugar'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editLugar() {
            this.$refs['frm-lugar'].show();
            this.$refs['view-lugar'].hide();
        },
        cancelLugar() {
            if (this.lugar.id) {
                this.$refs['view-lugar'].show();
            }
            this.$refs['frm-lugar'].hide();
        },
        saveLugar() {
            this.ss.storeLugar(this.lugar).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-lugar'].hide();
                    this.$refs['datatable-lugar'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteLugar() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyLugar(this.lugar)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-lugar'].hide();
                                this.$refs['datatable-lugar'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Lugar').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showLugar(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
